module.exports = __webpack_public_path__ + "assets/img/icon_free.ad027d76.png";